<script setup>
import {useSystem} from "../../store/system";
import {onMounted} from "vue";

const systemStore = useSystem()

onMounted(() => {
  // 动态雾霾效果
  if (document.querySelector('.section__canvas--second')) {
    VANTA.FOG({
      el: "#canvas2",
      mouseControls: true,
      touchControls: true,
      gyroControls: false,
      minHeight: 200.00,
      minWidth: 200.00,
      highlightColor: 0xA034FA,
      midtoneColor: 0xA034FA,
      lowlightColor: 0xE66C12,
      baseColor: 0x16142A,
      blurFactor: 0.90,
      speed: 5.70,
      zoom: 1.00
    })
  }

})
</script>

<template>
  <div>
    <!-- head -->
    <div class="section section--head">
      <div class="container">
        <div class="row">
          <!-- title -->
          <div class="col-12">
            <div class="section__title">
              <h1>Promoter</h1>
              <!--              <p>Centure is an affordable and successful crypto investment.</p>-->
            </div>
          </div>
          <!-- end title -->
        </div>
      </div>
    </div>
    <!-- end head -->


    <!-- Promoter -->
    <section class="section">
      <div class="container">
        <div class="row row--relative">
          <div class="col-12 p-0">
            <div class="company mt-0">
              <el-row :gutter="30" class="w-full m-0">
                <el-col :span="24" :md="12">
                  <el-image class="w-full rounded-xl" :src="systemStore.getFrontModuleContent(13).image" fit="contain"></el-image>
                </el-col>
                <el-col :span="24" :md="12">
                  <h2 class="company__title xs:text-center">{{systemStore.getFrontModuleContent(13).title}}</h2>
                  <div class="feature__text text-left mt-3">
                    {{systemStore.getFrontModuleContent(13).description}}
                  </div>
                  <button class="w-full justify-self-center mt-4 section__btn section__btn--light" type="button">Get Your Referral Link <i class="ti ti-arrow-move-right ml-2 text-[28px]"></i></button>
                </el-col>
              </el-row>

              <!-- design elements -->
              <span class="block-icon" :class="systemStore.getBlockIconColor()">
							  <i class="ti ti-coin"></i>
						  </span>
              <span class="screw screw--lines-bl"></span>
              <span class="screw screw--lines-br"></span>
              <span class="screw screw--lines-tr"></span>
            </div>

            <!-- animation background -->
            <div class="top-0 left-0 bottom-0 w-full h-full section__canvas section__canvas--second" id="canvas2"></div>
          </div>
        </div>
      </div>
    </section>
    <!-- end Promoter -->

    <!-- How to Get Affiliate Links -->
    <div class="container">
      <!-- head -->
      <div class="section section--head mt-0 pt-0">
        <div class="container">
          <div class="row">
            <!-- title -->
            <div class="col-12 col-md-10 offset-md-1 col-lg-6 offset-lg-3">
              <div class="section__title">
                <h1>{{systemStore.getFrontModuleContent(11).title}}</h1>
                <p>{{systemStore.getFrontModuleContent(11).sub_title}}</p>
              </div>
            </div>
            <!-- end title -->
          </div>
        </div>
      </div>
      <!-- end head -->
      <el-row :gutter="30" class="section mt-0">
        <el-col :span="24" :md="8" v-for="(item, index) in systemStore.getFrontModuleContent(11)?.json_data" :key="index">
          <div class="stats text-white h-auto">

            <div class="px-[3rem] text-center py-[2rem]">
              <div class="font-bold text-[18px] py-2">{{item.title}}</div>
              <div class="text-[16px] text-left line-clamp-2">{{item.desc}}</div>
            </div>

            <!-- design elements -->
            <span class="stats__dodger stats__dodger--left stats__dodger--purple"></span>
            <span class="stats__dodger stats__dodger--right stats__dodger--purple"></span>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- end How to Get Affiliate Links -->


    <!-- How to become a promoter -->
    <div class="container">
      <!-- head -->
      <div class="section section--head mt-0 pt-0">
        <div class="container">
          <div class="row">
            <!-- title -->
            <div class="col-12 col-md-10 offset-md-1 col-lg-6 offset-lg-3">
              <div class="section__title">
                <h1>{{systemStore.getFrontModuleContent(12).title}}</h1>
                <p>{{systemStore.getFrontModuleContent(12).sub_title}}</p>
              </div>
            </div>
            <!-- end title -->
          </div>
        </div>
      </div>
      <!-- end head -->
      <el-row :gutter="30" class="section mt-0">
        <el-col :span="24" :md="8" v-for="(item, index) in systemStore.getFrontModuleContent(12)?.json_data" :key="index">
          <div class="stats text-white h-full justify-start">
            <div class="px-[3rem] text-center py-[2rem]">
              <el-avatar size="large" :src="item.image"></el-avatar>
              <div class="font-bold text-[18px] py-2">{{item.title}}</div>
              <div class="text-[16px] text-left">{{item.desc}}</div>
            </div>

            <!-- design elements -->
            <span class="stats__dodger stats__dodger--left stats__dodger--purple"></span>
            <span class="stats__dodger stats__dodger--right stats__dodger--purple"></span>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- end How to become a promoter -->

    <!-- join -->
    <section class="section">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="roadmap tw-mt-4 tw-rounded-md card-bg-active !tw-justify-between" style="align-items: normal !important;">
              <el-row class="w-full">
                <el-col :span="24" :md="18">
                  <div class="tw-text-[2rem] tw-font-bold">{{systemStore.getFrontModuleContent(25).title}}</div>
                  <div>{{systemStore.getFrontModuleContent(25).sub_title}}</div>
                </el-col>
                <el-col :span="24" :md="6" class="tw-content-center">
                  <button class="section__btn xs:tw-justify-self-center sm:tw-justify-self-end xs:tw-mt-5 md:tw-mt-0" type="button" @click="router.push({path:'/Dashboard'})">{{systemStore.getFrontModuleContent(25).description}}</button>
                </el-col>
              </el-row>

              <!-- design elements -->
              <span class="block-icon block-icon--purple">
							  <i class="ti ti-topology-star-ring"></i>
						  </span>
              <span class="screw screw--lines-bl"></span>
              <span class="screw screw--lines-br"></span>
              <span class="screw screw--lines-tr"></span>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- end join -->

  </div>
</template>

<style scoped>

</style>
